import BaseViz from './BaseViz'
import SegmentedBarChartChart from '../charts/SegmentedBarChartChart'
import SegmentedBarChartDataController from '../viz_behaviors/SegmentedBarChartDataController'
export default class SegmentedBarChartViz extends BaseViz {
  static defaultConfig = {
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical', 'single'],
        nonEditable: true,
        exposed: false,
      },
    },
    AxisHelper: {
      x: {
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
        domain: {
          nonEditable: true,
        },
      },
    },
  }
  static chartClass = SegmentedBarChartChart
  static dataControllerClass = SegmentedBarChartDataController
}
